export const environment = {
  production: true,
  // apiUrl: 'https://52.59.8.95/api/v1',
  // apiUrlv2: 'https://52.59.8.95/api/v2'
  apiUrl: 'https://apipre.windowsight.com/api/v2',
  apiUrlv2: 'https://apipre.windowsight.com/api/v2',
  urlBaseEvents: "http://apipre.windowsight.com:8082/api/v2",
  firebaseConfig: {
    apiKey: "AIzaSyAAI-8yM2b3V5vRBju_rMrdTb0AgKJSlFI",
    authDomain: "windowsight-dev.firebaseapp.com",
    databaseURL: "https://windowsight-dev.firebaseio.com",
    projectId: "windowsight-dev",
    storageBucket: "windowsight-dev.appspot.com",
    messagingSenderId: "908930512030",
    appId: "1:908930512030:web:e20714e8707919aaf6378f"
  }

};

export const HOME_URL = 'https://pre.windowsight.com';
export const ARTIST_URL = 'https://pre-artist.windowsight.com';
export const WEB_URL = 'https://pre-web.windowsight.com';
export const COOKIE_PREFIX = 'pre-';
export const COOKIE_DOMAIN = '.windowsight.com';
export const APP_URL = 'https://windowsightpre.page.link/Home';
export const APP_WEB_URL = 'https://pre.windowsight.com/download-app/';
export const ADDON_HPP_URL = 'https://hpp.sandbox.addonpayments.com/pay';
export const ADDON_HPP_RETURN_URL = 'https://pre-web.windowsight.com/';
export const ADDON_HPP_RETURN_BACKEND_URL = '/card/hppUrlResponse';



